import type { SVGProps } from 'react';

const FloatingKakao = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' height={52} width={52} xmlns='http://www.w3.org/2000/svg' {...props}>
    <g filter='url(#floatingKakao)'>
      <rect fill='#FEE500' height={40} rx={20} width={40} x={4} y={4} />
      <path
        d='M23.99 13.602c-6.222 0-11.24 4.015-11.24 8.889 0 3.163 2.088 5.933 5.219 7.515l-1.06 3.958a.337.337 0 0 0 .08.345.353.353 0 0 0 .233.088.337.337 0 0 0 .193-.08l4.56-3.075c.673.093 1.352.141 2.032.145 6.214 0 11.24-4.015 11.24-8.896 0-4.882-5.042-8.889-11.256-8.889Z'
        fill='#392020'
      />
      <path
        d='M16.683 21.086h-1.229a.803.803 0 0 1-.433-.112.499.499 0 0 1-.225-.33.706.706 0 0 1 0-.128.499.499 0 0 1 .193-.418.802.802 0 0 1 .481-.152h3.702a.747.747 0 0 1 .433.12.465.465 0 0 1 .225.33c.004.04.004.08 0 .12a.514.514 0 0 1-.193.425.739.739 0 0 1-.473.145h-1.189v4.223a.65.65 0 0 1-.184.49.618.618 0 0 1-.466.184.65.65 0 0 1-.418-.136.602.602 0 0 1-.216-.361.662.662 0 0 1 0-.177l-.008-4.223ZM20.184 20.258a.555.555 0 0 1 .232-.321.746.746 0 0 1 .402-.096h.305a.803.803 0 0 1 .425.104.658.658 0 0 1 .274.393l1.605 4.537c.042.118.077.239.105.361.002.05.002.102 0 .153a.538.538 0 0 1-.177.417.586.586 0 0 1-.433.177.554.554 0 0 1-.579-.37l-.337-.987h-2.111l-.338.987a.547.547 0 0 1-.586.37.602.602 0 0 1-.377-.12.554.554 0 0 1-.2-.338.724.724 0 0 1 0-.136.705.705 0 0 1 0-.241c0-.088.055-.185.088-.273l1.702-4.617Zm.802 1.052-.762 2.409h1.517l-.755-2.41ZM23.72 20.515a.683.683 0 0 1 .176-.49.626.626 0 0 1 .474-.184.683.683 0 0 1 .417.136.61.61 0 0 1 .209.37.596.596 0 0 1 0 .168v4.223h2.208a.803.803 0 0 1 .434.12.49.49 0 0 1 .224.33v.12a.497.497 0 0 1-.192.418.803.803 0 0 1-.482.152h-2.714a.803.803 0 0 1-.49-.128.618.618 0 0 1-.24-.402 2.02 2.02 0 0 1 0-.265l-.025-4.568ZM28.003 20.515a.714.714 0 0 1 .177-.49.706.706 0 0 1 .891-.048c.114.094.191.225.217.37.004.056.004.112 0 .168v1.968l2.031-2.345c.079-.08.162-.155.25-.225a.514.514 0 0 1 .272-.072c.14 0 .278.041.394.12a.49.49 0 0 1 .208.322.12.12 0 0 1 0 .048.136.136 0 0 0 0 .056.49.49 0 0 1-.064.24c-.042.079-.094.151-.152.218l-1.333 1.46 1.605 2.49v.08c.084.115.149.242.193.378v.04a.579.579 0 0 1-.2.497.755.755 0 0 1-.466.153.634.634 0 0 1-.321-.072.802.802 0 0 1-.257-.281l-1.494-2.409-.714.747v1.34a.715.715 0 0 1-.177.49.65.65 0 0 1-.482.185.643.643 0 0 1-.41-.137.602.602 0 0 1-.216-.36.653.653 0 0 1 0-.178l.048-4.753Z'
        fill='#FEE500'
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height={52}
        id='floatingKakao'
        width={52}
        x={0}
        y={0}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx={2} dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_4904_36056' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_4904_36056' result='shape' />
      </filter>
    </defs>
  </svg>
);
export default FloatingKakao;
